module.exports = __webpack_public_path__ + "static/img/hongbao-red-shoudan.5013717.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/activity/WZBankPC/hongbao-red-shoudan.png
// module id = xy4w
// module chunks = 69